import { defineMessages } from 'react-intl';

export const messages: {
	searchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchIconLabel: {
		id: 'dropdown_search_icon_label',
		defaultMessage: 'Search',
		description:
			'Accessible label for the search icon displayed inside the auto-suggestion dropdown input field.',
	},
});
